import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import classRoomImg from "../../../../assets/img/teacherDashboard/Classroom.png";
import { useNavigate } from "react-router-dom";
import NotificationTable from "./NotificationTable";
import { useGetSentNotificationList } from "../../../../hooks/organization/notification/useGetSentNotificationList";

const Notification = () => {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);

    const {
        notifications,
        meta,
        loading,
        error,
        getSentNotifications,
    } = useGetSentNotificationList();

    useEffect(() => {
        getSentNotifications({ page: currentPage });
    }, [currentPage]);

    const handleRefresh = () => {
        getSentNotifications({ page: currentPage });
    };

    return (
        <div className="classroom-cnt">
            <div className="classroom-container">
                <img src={classRoomImg} className="img" alt="Notification Centre" />
                <h2 className="text">Notification Centre</h2>
            </div>

            <div className="btn-container">
                <Button
                    className="primary-btn"
                    onClick={() => {
                        navigate("/organization/notification/create");
                    }}
                >
                    Create New
                </Button>
            </div>
            <div>
                <NotificationTable
                    notifications={notifications}
                    loading={loading}
                    error={error}
                    metaData={meta}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    handleRefresh={handleRefresh}
                />
            </div>
        </div>
    );
};

export default Notification;
